import { Button, Tooltip } from "antd";

export const SUBMIT_DISABLED_DATE_ORDER_ERROR_TOOLTIP =
  "Some milestone dates need to be corrected before you can submit.";

function MaterialDateConfirmationFooter({
  submitting,
  hasDateChanges = false,
  onConfirmDates,
  buttonText,
  disabled,
  disabledTooltip
}: {
  submitting?: boolean;
  hasDateChanges?: boolean;
  onConfirmDates: () => void;
  buttonText?: string;
  disabled?: boolean;
  disabledTooltip?: string;
}) {
  const confirmButton = (
    <Button
      type="primary"
      htmlType="button"
      loading={submitting}
      disabled={disabled}
      onClick={onConfirmDates}
      className="w-full"
      data-testid="material-date-confirmation-confirm-btn"
    >
      {buttonText ?? (hasDateChanges ? "Submit changes" : "Confirm dates")}
    </Button>
  );

  const shouldShowDisabledTooltip = Boolean(disabled && disabledTooltip);

  return (
    <div
      className="shrink-0 px-4 lg:px-7 py-4 flex items-center lg:justify-end bg-white border-0 border-t border-solid border-color-2"
      data-testid="material-date-confirmation-footer"
    >
      {shouldShowDisabledTooltip ? (
        <Tooltip title={disabledTooltip}>
          <span
            className="inline-block w-full lg:w-auto lg:min-w-[140px]"
            data-testid="material-date-confirmation-confirm-btn-tooltip"
          >
            {confirmButton}
          </span>
        </Tooltip>
      ) : (
        <span className="inline-block w-full lg:w-auto lg:min-w-[140px]">
          {confirmButton}
        </span>
      )}
    </div>
  );
}

export default MaterialDateConfirmationFooter;
